<div class="container change-bp-dialog">
  <div class="dialog-header">
    <div class="dialog-header__icon" aria-hidden="true">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
      </svg>
    </div>
    <h1 mat-dialog-title class="dialog-title">Alterar o BP</h1>
    <p class="dialog-subtitle">Atualize o código BP associado ao seu usuário</p>
  </div>

  <div mat-dialog-content class="dialog-content">
    <form [formGroup]="form">
      <div class="form-group">
        <label for="fromBp">Alterar De:</label>
        <input id="fromBp" class="input_bp" type="text" name="myBp"
          placeholder="Exemplo: 00123456"
          required formControlName="from">
        @if (!form.controls.from.valid && confirmed) {
          <app-error-form>
            Informe o BP do seu usuário.
          </app-error-form>
        }
      </div>

      <div class="form-group container-new-bp">
        <label for="toBp">Para:</label>
        <input id="toBp" class="input_bp" type="text" name="newBp"
          placeholder="Exemplo: 00654321"
          required formControlName="to">
        @if (!form.controls.to.valid && confirmed) {
          <app-error-form>
            Informe o BP que deseja definir para o seu usuário.
          </app-error-form>
        }
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button class="btn btn-close" type="button" mat-dialog-close>Cancelar</button>
    <button class="btn btn-ok" type="button" mat-button (click)="confirm();">Alterar</button>
  </div>
</div>


